module.exports = {
      id: "icon-audio-instagram-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-audio-instagram",
      toString: function () {
        return this.url;
      }
    }